__turbopack_context__.v({
  "spinner": "Spinner-module__luOavG__spinner",
  "spinner-rotation": "Spinner-module__luOavG__spinner-rotation",
});
